define('drops/action/runtimeTypesProvider',[
    'lq/typesProvider',

    'drops/actionSlideshow/actionSlideshow',
    'drops/autoComplete/autoComplete',
    'drops/baiduMaps/baiduMaps',
    'drops/barCode/barCode',
    'drops/boolImageInput/boolImageInput',
    'drops/boolInput/boolInput',
    'drops/businessProcess/businessProcess',
    'drops/businessProcessCanvas/businessProcessCanvas',
    'drops/button/button',
    'drops/buttonWithIcon/buttonWithIcon',
    'drops/calendar/calendar',
    'drops/calendarDayView/calendarDayView',
    'drops/calendarPlanningView/calendarPlanningView',
    'drops/calendarPlanningViewGroupItem/calendarPlanningViewGroupItem',
    'drops/calendarTimeSlotItem/calendarTimeSlotItem',
    'drops/calendarItem/calendarItem',
    'drops/calendarMonthView/calendarMonthView',
    'drops/calendarWeekView/calendarWeekView',
    'drops/calendarYearView/calendarYearView',
    'drops/bucketDrop/bucketDrop',
    'drops/captcha/captcha',
    'drops/carousel/carousel',
    'drops/carouselControl/carouselControl',
    'drops/carouselPanel/carouselPanel',
    'drops/carouselTabControl/carouselTabControl',
    'drops/chart/chart',
    'drops/chart_v2/chart_v2',
    'drops/circle/circle',
    'drops/circleShape/circleShape',
    'drops/clock/clock',
    'drops/colorPicker/colorPicker',
    'drops/custom/custom',
    'drops/dataGrid/dataGrid',
    'drops/dateInput/dateInput',
    'drops/documentView/documentView',
    'drops/dropdown/dropdown',
    'drops/dropField/dropField',
    'drops/dynamicBarcode/dynamicBarcode',
    'drops/dynamicIframe/dynamicIframe',
    'drops/dynamicImage/dynamicImage',
    'drops/dynamicSlideshow/dynamicSlideshow',
    'drops/dynamicText/dynamicText',
    'drops/dynamicVideo/dynamicVideo',
    'drops/embed/embed',
    'drops/entityFilter/entityFilter',
    'drops/entityFiltersPanel/entityFiltersPanel',
    'drops/errorHandling/errorHandling',
    'drops/filter/filter',
    'drops/frame/frame',
    'drops/gauge/gauge',
    'drops/googleMap/googleMap',
    'drops/grid/grid',
    'drops/gridLayout/gridLayout',
    'drops/helper/helper',
    'drops/hotspot/hotspot',
    'drops/iframe/iframe',
    'drops/image/image',
    'drops/imageKpi/imageKpi',
    'drops/input/input',
    'drops/jitsiMeeting/jitsiMeeting',
    'drops/list/list',
    'drops/listItem/listItem',
    'drops/magicWand/magicWand',
    'drops/matrix/matrix',
    'drops/milestones/milestones',
    'drops/mockList/mockList',
    'drops/modalAction/modalAction',
    'drops/modalPopup/modalPopup',
    'drops/multiSelect/multiSelect',
    'drops/numericInput/numericInput',
    'drops/pagination/pagination',
    'drops/pattern/pattern',
    'drops/payment/payment',
    'drops/planningGraph/planningGraph',
    'drops/progressBar/progressBar',
    'drops/pushNotificationReceiver/pushNotificationReceiver',
    'drops/qrCode/qrCode',
    'drops/qrCode_v2/qrCode_v2',
    'drops/radioButton/radioButton',
    'drops/radioButtonGroup/radioButtonGroup',
    'drops/radioButtonGroupV2/radioButtonGroupV2',
    'drops/radioButtonList/radioButtonList',
    'drops/rectangle/rectangle',
    'drops/requirementsGraph/requirementsGraph',
    'drops/richTextEditor/richTextEditor',
    'drops/richTextTemplateEditor/richTextTemplateEditor',
    'drops/runtimeQueryBuilder/runtimeQueryBuilder',
    'drops/simpleSpreadsheet/simpleSpreadsheet',
    'drops/sketchPad/sketchPad',
    'drops/slider/slider',
    'drops/stack/stack',
    'drops/taskProgress/taskProgress',
    'drops/text/text',
    'drops/textArea/textArea',
    'drops/timeInput/timeInput',
    'drops/timer/timer',
    'drops/treeView/treeView',
    'drops/treeView_v2/treeView_v2',
    'drops/tweetDrop/tweetDrop',
    'drops/video/video',
    'drops/documentPreviewer/documentPreviewer',
    'drops/googlePlaces/googlePlaces',
    'drops/dropDown_v2/dropDown_v2',
    'drops/dynamicGridLayout/dynamicGridLayout',
    'drops/ganttChart/ganttChart',
    'drops/normalDistribution/normalDistribution',
    'drops/contentRegion/contentRegion',
    'drops/scrollSync/scrollSync',
    'drops/documentIntelligencePreviewer/documentIntelligencePreviewer'
], function (TypesProvider) {
    'use strict';

    var dropTypes = Array.prototype.slice.call(arguments, 1);
    return new TypesProvider(dropTypes);
});
